import { Controller } from "@hotwired/stimulus"

// Toggles visibility of a target panel based on a checkbox state.
// Also toggles `required` on inputs inside the panel and clears values when hidden.
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const checked = event.target.checked
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", !checked)
      panel.querySelectorAll("input, select, textarea").forEach(input => {
        if (checked) {
          if (input.dataset.wasRequired) input.required = true
          if (input.dataset.previousValue) {
            input.value = input.dataset.previousValue
            delete input.dataset.previousValue
          }
        } else {
          if (input.required) input.dataset.wasRequired = "true"
          input.required = false
          if (input.value) {
            input.dataset.previousValue = input.value
            input.value = ""
          }
        }
      })
    })
  }
}
